export default ['MTN_Rwanda', 'AIRTEL_Rwanda'];
